import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import { Asset } from '@mux/mux-node';

interface tierState {
  value: Tier[];
  isLoading: boolean;
  error: string;
}

const initialState: tierState = {
  value: [],
  isLoading: false,
  error: '',
};

const slice = createSlice({
  name: 'tier',
  initialState,
  reducers: {
    setTiers(state, action: PayloadAction<Tier[]>) {
      const tiers = action.payload;
      state.value = tiers;
    },
    getTierRequested(state, action: PayloadAction<{ projectId: number }>) {
      state.isLoading = true;
      state.value = [];
    },
    getTierSucceeded(state, action: PayloadAction<Tier[]>) {
      const tier = action.payload;
      state.value = tier;
    },
    getTierFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;
      state.error = message;
    },

    createTierRequested(state, action: PayloadAction<{ projectId: number; tier: Tier }>) {
      state.isLoading = true;
    },
    createTierSucceeded(state, action: PayloadAction<Tier>) {
      const tier = action.payload;
      state.value?.push(tier);
    },
    createTierFailed(state, action: PayloadAction<SagaError>) {
      const { message } = action.payload;
      state.error = message;
    },
  },
});

export default slice.reducer;
export const {
  setTiers,
  getTierRequested,
  getTierSucceeded,
  getTierFailed,
  createTierRequested,
  createTierSucceeded,
  createTierFailed,
} = slice.actions;
